export enum SUPPORTED_CHAIN_IDS {
  ETHEREUM = 1,
  ARBITRUM = 42161,
  POLYGON = 137,
  BASE = 8453,
}
